import ContactForm from '../components/ContactForm';
import '../styles/ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="contact-page-content">
        {/* Section d'informations de contact et Google Map */}
        <div className="contact-info-container">
          <div className="contact-info">
            <h2>Adresse</h2>
            <p>251 Avenue de La Porte des Alpes</p>
            <p>Plan du Var</p>
            <p>06670 Levens</p>

            <h2>Téléphone</h2>
            <p><a href="tel:+33645424233">06.45.42.42.33</a></p>

            <h2>Email</h2>
            <p><a href="mailto:secretariat@nms06.fr">secretariat@nms06.fr</a></p>
          </div>

          <div className="google-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2876.907871923485!2d7.194429529009494!3d43.857738162083564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cdd17be59168f3%3A0x82be4762b3d3a0a2!2sNice%20Moulins%20Solidarit%C3%A9s%2006!5e0!3m2!1sfr!2sfr!4v1733784284721!5m2!1sfr!2sfr"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map Location"
            ></iframe>
          </div>
        </div>

        {/* Section du formulaire de contact et de l'image */}
        <div className="contact-form-container">
          <ContactForm />
          <div className="form-image-container">
            <img
              src="/Nono.png"
              alt="Contact Illustration"
              className="form-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
